module.exports = {
  name: 'file', base: '_field', prototype: {
    element_selector: 'input[type=file]'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/file.js
 ** module id = 17
 ** module chunks = 0
 **/